const STORAGE_KEY = 'paymentSource';
const WHATSAPP_SOURCE = 'whatsapp';

export const capturePaymentSource = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('source') === WHATSAPP_SOURCE) sessionStorage.setItem(STORAGE_KEY, WHATSAPP_SOURCE);
  } catch {
    // Ignore parse/storage access errors (e.g. storage/cookies disabled).
  }
};

export const getPaymentSource = () => {
  switch (sessionStorage.getItem(STORAGE_KEY)) {
    case WHATSAPP_SOURCE:
      return WHATSAPP_SOURCE;
    default:
      return undefined;
  }
};
